import React, { useEffect } from 'react';
import queryString from 'query-string';
import { adobeDownloadDatasheet, logEventType } from '../../utils/analytics/adobe/adob';
import Box from '@material-ui/core/Box';
import LinearProgress from '@material-ui/core/LinearProgress';
import { localDownloadDatasheet } from '../../utils/analytics/local';

const LinkRedirect = () => {
	const urlParameters = window.location.search;
	useEffect(() => {
		const trackingParameters = queryString.parse(urlParameters);
		const redirectLink = trackingParameters.redirectLink;

		const logEvents = () => {
			if (trackingParameters.logEventType === logEventType.DATASHEETLOG) {
				Promise.allSettled([
					adobeDownloadDatasheet(trackingParameters),
					localDownloadDatasheet(trackingParameters)
				]).then(() =>
					setTimeout(() => {
						redirect();
					}, 150)
				);
			}
		};

		const redirect = () => {
			window.location.replace(redirectLink);
		};

		logEvents();

		setTimeout(() => {
			redirect();
		}, 4000);
	}, []);

	return (
		<Box sx={{ width: '100%' }}>
			<LinearProgress />
		</Box>
	);
};

export default LinkRedirect;
